import {useVentrataClient} from 'hooks/useVentrataClient'
import {useCallback} from 'react'
import {Params, Ventrata} from 'types'
import {useRecaptchaToken, withRecaptchaRetry} from 'utils/recaptcha'

export const useAddBookingApiMethod = () => {
  const ventrata = useVentrataClient()
  const createRecaptchaToken = useRecaptchaToken()

  return useCallback(
    async ({orderId, bookingUuid, productId, optionId, availabilityId, unitItems}: Params.AddBooking) => {
      return withRecaptchaRetry('cart_add', createRecaptchaToken, async (token) => {
        const recaptchaEnterprise: Params.RecaptchaToken = {token}

        const {data} = await ventrata.post<Ventrata.Booking>(
          `/bookings`,
          {
            orderId,
            uuid: bookingUuid,
            productId,
            optionId,
            unitItems,
            availabilityId,
            recaptchaEnterprise,
          },
          {
            headers: {
              'Octo-Capabilities': 'octo/cart',
            },
          }
        )

        return data
      })
    },
    [ventrata, createRecaptchaToken]
  )
}
